import { useNavigate } from 'react-router-dom';

import { NotificationCard as SharedNotificationCard } from 'us-react-components/dist/NotificationCard/NotificationCard';
import { Notification } from 'us-web-services';

interface Props {
  notification: Notification;
}

export const NotificationCard = ({ notification }: Props): JSX.Element => {
  const navigate = useNavigate();

  const goToContext = (): void => {
    if (notification.bookingId) {
      navigate(`/bookings/${notification.bookingId}`);
    } else if (notification.referredSitterId) {
      navigate(`/sitter/${notification.referredSitterId}`);
    } else if (notification.jobId && notification.sender?.id) {
      navigate(`/job/${notification.jobId}/applicant/${notification.sender.id}`);
    } else {
      navigate('/sitters');
    }
  };

  return (
    <SharedNotificationCard
      id={notification.id}
      unread={notification.read === false}
      label={notification.label}
      message={notification.message}
      senderPictureUrl={notification.sender?.pictureUrl}
      onSelect={goToContext}
    />
  );
};
